import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class Gpt3Service {
  constructor(private http: HttpClient) {}

  retryObservable(observable, maxRetries = 2) {
    const onSuccess = (subscriber, response) => {
      subscriber.next(response);
      subscriber.complete();
    };

    const onError = subscriber => {
      subscriber.error();
      subscriber.complete();
    };

    const onRetry = subscriber => {
      this.retryObservable(observable, maxRetries - 1).subscribe(
        response => {
          onSuccess(subscriber, response);
        },
        () => {
          onError(subscriber);
        },
      );
    };

    return new Observable(subscriber => {
      observable.subscribe(
        response => {
          onSuccess(subscriber, response);
        },
        () => {
          if (maxRetries <= 0) {
            onError(subscriber);
          } else {
            onRetry(subscriber);
          }
        },
      );
    });
  }

  generateTitle(topic: string, maxRetries = 2) {
    return this.retryObservable(
      this.http.get(`${environment.gpt3Api}/gen-title`, {
        params: { topic: topic },
      }),
      maxRetries,
    );
  }

  generateLong(topic: string, title, short, maxRetries = 2) {
    return this.retryObservable(
      this.http.get(`${environment.gpt3Api}/gen-long`, {
        params: { topic: topic, title: title, short: short },
      }),
      maxRetries,
    );
  }

  generateShort(topic, title, maxRetries = 2) {
    return this.retryObservable(
      this.http.get(`${environment.gpt3Api}/gen-short`, {
        params: { topic: topic, title: title },
      }),
      maxRetries,
    );
  }

  summarizeShort(long, maxRetries = 2) {
    return this.retryObservable(
      this.http.get(`${environment.gpt3Api}/summarize-short`, {
        params: { long: long },
      }),
      maxRetries,
    );
  }

  summarizeTitle(short, long = '', maxRetries = 2) {
    return this.retryObservable(
      this.http.get(`${environment.gpt3Api}/summarize-title`, {
        params: { short: short, long: long },
      }),
      maxRetries,
    );
  }

  generateFeedback(topic, title, short, long, maxRetries = 2) {
    return this.retryObservable(
      this.http.get(`${environment.gpt3Api}/gen-feedback`, {
        params: { topic: topic, title: title, short: short, long: long },
      }),
      maxRetries,
    );
  }
}
